import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  empleado: string;
  oficina: string;

  constructor(private router: Router) {
  }

  ngOnInit() {
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.empleado = currentUser.userSystem.desPerSel;
    this.oficina = currentUser.userSystem.desDepSel;
  }


  searchMobileActive = false;

  toggleSearchMobile(){
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts